import React, { useState } from "react";
import { Tab } from "semantic-ui-react";
import { ListRecords } from "../../../components/Admin/Records";
import { useLanguage } from "../../../contexts";
import "./Records.scss";

export function Records() {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;
  const [reload, setReload] = useState(false);
  const onReload = () => setReload((prev) => !prev);

  const panes = [
    {
      menuItem: t("active_records"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListRecords active={true} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: t("inactive_records"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListRecords active={false} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <div className="records-page" style={{ padding: "0 0 1.5rem" }}>
      <div className="records-page-header-wrapper">
        <div className="records-page-header">
          <span className="records-page-title">{t("records")}</span>
        </div>
      </div>
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </div>
  );
}
